(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-home-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-home-film')) {
    customElements.define('hf-home-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        const video = this.querySelector('video');
        const toggle = this.querySelector('button');
        if (!video || !toggle) return;
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        let inView = true;
        let explicitPause = false;
        let wantsPlayback = !motion.matches && !connection?.saveData;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        const updateControl = () => {
          const playing = !video.paused;
          this.toggleAttribute('data-playing', playing);
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          toggle.querySelector('span').textContent = label;
          toggle.setAttribute('aria-label', label);
        };
        const syncPlayback = () => {
          if (!wantsPlayback || !inView || document.hidden) {
            video.pause();
            updateControl();
            return;
          }
          video.play().catch(updateControl);
        };
        toggle.hidden = false;
        updateControl();
        toggle.addEventListener('click', () => {
          wantsPlayback = video.paused;
          explicitPause = !wantsPlayback;
          syncPlayback();
        }, options);
        video.addEventListener('play', updateControl, options);
        video.addEventListener('pause', updateControl, options);
        video.addEventListener('error', () => {toggle.hidden = true;}, options);
        document.addEventListener('visibilitychange', syncPlayback, options);
        motion.addEventListener('change', () => {
          wantsPlayback = !motion.matches && !explicitPause && !connection?.saveData;
          syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            inView = entries[0].isIntersecting;
            syncPlayback();
          }, {threshold: 0.05});
          this.observer.observe(this);
        }
        syncPlayback();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hf-home-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hf-product-discovery')) {
  customElements.define('hf-product-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const nav = this.querySelector('.hf-discovery__tabs');
      const tabs = Array.from(this.querySelectorAll('.hf-discovery__tab'));
      const panels = Array.from(this.querySelectorAll('.hf-discovery__panel'));
      if (!nav || tabs.length !== panels.length || !tabs.length) return;

      const controller = new AbortController();
      const options = { signal: controller.signal };
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const compact = matchMedia('(max-width: 600px)');
      const indicator = document.createElement('span');
      indicator.className = 'hf-discovery__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      indicator.hidden = true;
      nav.append(indicator);
      let selectedTab;
      let indicatorAnimation;
      let panelAnimation;

      const positionIndicator = (animate = false) => {
        if (!selectedTab) return;
        const previous = getComputedStyle(indicator).transform;
        indicatorAnimation?.cancel();
        indicator.hidden = compact.matches;
        nav.toggleAttribute('data-indicator', !compact.matches);
        if (compact.matches) return;
        const tabRect = selectedTab.getBoundingClientRect();
        const navRect = nav.getBoundingClientRect();
        const transform = `translateX(${tabRect.left - navRect.left + nav.scrollLeft}px) scaleX(${tabRect.width})`;
        indicator.style.transform = transform;
        if (animate && !reduced.matches && indicator.animate && previous !== 'none') {
          indicatorAnimation = indicator.animate([{ transform: previous }, { transform }], {
            duration: 240, easing: 'cubic-bezier(.22,1,.36,1)'
          });
        }
      };

      const activate = (tab, focus = false, animate = true) => {
        const changed = selectedTab !== tab;
        panelAnimation?.cancel();
        selectedTab = tab;
        this.selectedCategory = tab.dataset.category;
        tabs.forEach((item, index) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          panels[index].hidden = !selected;
        });
        positionIndicator(changed && animate);
        const panel = panels[tabs.indexOf(tab)];
        if (changed && animate && !reduced.matches && panel.animate) {
          panelAnimation = panel.animate([
            { opacity: .82, transform: compact.matches ? 'none' : 'translateY(6px)' },
            { opacity: 1, transform: compact.matches ? 'none' : 'translateY(0)' }
          ], { duration: compact.matches ? 160 : 220, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
        if (focus) tab.focus({ preventScroll: true });
      };

      nav.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          event.preventDefault();
          activate(tab);
        }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next], true);
        }, options);
      });
      const linkedCategory = () => panels.find(panel => '#' + panel.id === window.location.hash)?.dataset.category;
      const initialCategory = this.selectedCategory || linkedCategory() || this.dataset.defaultCategory;
      activate(tabs.find(tab => tab.dataset.category === initialCategory) || tabs[0], false, false);
      this.dataset.enhanced = 'true';
      window.addEventListener('hashchange', () => {
        const linkedTab = tabs.find(tab => tab.dataset.category === linkedCategory());
        if (linkedTab) activate(linkedTab, false, false);
      }, options);
      reduced.addEventListener('change', () => {
        panelAnimation?.cancel();
        positionIndicator();
      }, options);
      compact.addEventListener('change', () => {
        panelAnimation?.cancel();
        positionIndicator();
      }, options);
      const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => positionIndicator()) : null;
      resize?.observe(nav);
      tabs.forEach(tab => resize?.observe(tab));
      window.addEventListener('resize', () => positionIndicator(), options);
      document.fonts?.ready.then(() => {
        if (!controller.signal.aborted) positionIndicator();
      });
      this.cleanup = () => {
        controller.abort();
        resize?.disconnect();
        panelAnimation?.cancel();
        indicatorAnimation?.cancel();
        indicator.remove();
        nav.removeAttribute('data-indicator');
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
